var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSort = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#4A5661",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M10.5 5.127 6.686 1.313a1.5 1.5 0 0 0-1.061-.44m0 0c-.384 0-.768.148-1.061.441L.75 5.128M5.625.873v13.396M15.375.75v13.394m0 0c.384 0 .768-.146 1.061-.439l3.814-3.814m-4.875 4.253c-.384 0-.768-.147-1.061-.44L10.5 9.89"
})));
export default SvgSort;